// Centralized date/time formatting for Monterrey, Mexico (America/Monterrey, UTC-6, no DST).
// All admin dates must use these helpers to show consistent Monterrey local time.

const TZ = "America/Monterrey";

function safeDate(input) {
  if (!input) return null;
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return null;
  return d;
}

export function formatMtyDate(input) {
  const d = safeDate(input);
  if (!d) return "-";
  return d.toLocaleDateString("es-MX", {
    timeZone: TZ,
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatMtyDateShort(input) {
  const d = safeDate(input);
  if (!d) return "-";
  return d.toLocaleDateString("es-MX", {
    timeZone: TZ,
    day: "2-digit",
    month: "short",
    year: "2-digit",
  });
}

export function formatMtyTime(input) {
  const d = safeDate(input);
  if (!d) return "-";
  return d.toLocaleTimeString("es-MX", {
    timeZone: TZ,
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function formatMtyDateTime(input) {
  const d = safeDate(input);
  if (!d) return "-";
  return d.toLocaleString("es-MX", {
    timeZone: TZ,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function formatMtyDateTimeShort(input) {
  const d = safeDate(input);
  if (!d) return "-";
  return d.toLocaleString("es-MX", {
    timeZone: TZ,
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

/**
 * Returns YYYY-MM-DD for the date in Monterrey timezone.
 * Useful for matching backend daily_series keys.
 */
export function mtyDateKey(input) {
  const d = safeDate(input);
  if (!d) return "";
  // en-CA yields ISO-like YYYY-MM-DD format naturally
  return d.toLocaleDateString("en-CA", { timeZone: TZ });
}

/**
 * Returns relative "how long ago" label in Spanish.
 * Examples: "hace 3 min", "hace 2 h", "hace 1 d"
 */
export function formatMtyRelative(input) {
  const d = safeDate(input);
  if (!d) return "-";
  const diffMs = Date.now() - d.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return "ahora";
  if (diffMin < 60) return `hace ${diffMin} min`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `hace ${diffH} h`;
  const diffD = Math.floor(diffH / 24);
  if (diffD < 30) return `hace ${diffD} d`;
  return formatMtyDate(d);
}

export const MONTERREY_TZ = TZ;
